// extracted by mini-css-extract-plugin
export default {"defaultCard":"Hn-z","otherCards":"In-z","empty":"Jn-z","addNewItem":"Kn-z","disabled":"Ln-z","cardGrid":"Mn-z"};